import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  id: number;
  text: string;
  type: 'error' | 'info' | 'success';
}

/**
 * Minimal, dependency-free toast notifications. Messages auto-dismiss after a
 * few seconds and can be dismissed manually. Used by the GlobalErrorHandler to
 * surface errors that would otherwise be swallowed.
 */
@Injectable({ providedIn: 'root' })
export class ToasterService {
  private _messages = signal<ToastMessage[]>([]);
  private _nextId = 0;
  private readonly _timeoutMs = 6000;

  messages = this._messages.asReadonly();

  showError(text: string): void {
    const id = this._nextId++;
    this._messages.update(messages => [...messages, { id, text, type: 'error' }]);
    setTimeout(() => this.remove(id), this._timeoutMs);
  }

  showSuccess(text: string): void {
    const id = this._nextId++;
    this._messages.update(messages => [...messages, { id, text, type: 'success' }]);
    setTimeout(() => this.remove(id), this._timeoutMs);
  }

  showInfo(text: string): void {
    const id = this._nextId++;
    this._messages.update(messages => [...messages, { id, text, type: 'info' }]);
    setTimeout(() => this.remove(id), this._timeoutMs);
  }

  remove(id: number): void {
    this._messages.update(messages => messages.filter(m => m.id !== id));
  }
}
